angular.module('mercury.modules.reports.revenue')
.config(["$stateProvider", function($stateProvider) {
  $stateProvider.state('Reports.RevenueOverview', {
    url: '/revenue?report',
    templateUrl: 'modules/reports/revenue/overview.tpl.html',
    controller: 'ReportsRevenueOverviewCtrl'
  });
  $stateProvider.state('Reports.RevenueInvoices', {
    url: '/revenue/invoices?report',
    templateUrl: 'modules/reports/revenue/invoices.tpl.html',
    controller: 'ReportsRevenueInvoicesCtrl'
  });
  $stateProvider.state('Reports.RevenueOrders', {
    url: '/revenue/orders?report',
    templateUrl: 'modules/reports/revenue/orders.tpl.html',
    controller: 'ReportsRevenueOrdersCtrl'
  });
  $stateProvider.state('Reports.RevenueTransactions', {
    url: '/revenue/transactions?report',
    templateUrl: 'modules/reports/revenue/transactions.tpl.html',
    controller: 'ReportsRevenueTransactionsCtrl'
    // Left here as an example for when we implement custom placeholder pages
    //placeholder: {
    //  templateUrl: 'modules/reports/revenue/transactions.placeholder.tpl.html'
    //}
  });
  $stateProvider.state('Reports.RevenueAverage', {
    url: '/revenue/average?report',
    templateUrl: 'modules/reports/revenue/average.tpl.html',
    controller: 'ReportsRevenueAverageCtrl'
    // Left here as an example for when we implement custom placeholder pages
    //placeholder: {
    //  templateUrl: 'modules/reports/revenue/average.placeholder.tpl.html',
    //  controller: 'ReportsRevenueAveragePlaceholderCtrl'
    //}
  });
  $stateProvider.state('Reports.RevenueBudget', {
    url: '/revenue/budget?report',
    templateUrl: 'modules/reports/revenue/budget.tpl.html',
    controller: 'ReportsRevenueBudgetCtrl'
  });
  $stateProvider.state('Reports.RevenueTables', {
    url: '/revenue/tables?report',
    templateUrl: 'modules/reports/revenue/tables.tpl.html',
    controller: 'ReportsRevenueTablesCtrl'
  });
}]);
